import React, { Fragment } from "react";
import { Grid, Divider } from "@material-ui/core";
import _ from "lodash";
import styled from "styled-components";
import { connect as reduxConnect } from "react-redux";
import { connect, replace } from "formik";
import { compose } from "redux";
import moment from "moment";
import { AutoCompleteInput, MoneyInput, PercentInput, DatePicker, TextInput, IntegerInput } from "components/Global/FormikMaterial";
import loanStatuses from "constants/loanStatuses";

import {
  FinancialReportingChildSection,
  FinancialCovenantsChildSection,
  DefinitionsChildSection,
  CashManagementChildSection,
  EscrowAccountsChildSection,
  PartialReleaseChildSection,
  LeasingChildSection
} from "./CovenantsSectionChildren";
import {
  LoanPropertyLinkChildSection
} from "./LoanSectionChildren";
import { SectionTitle } from "./FormSectionComponents";

const VerticalSpacer = styled.div`
height:30px;
display:block;
`;

class CovenantsSection extends React.Component {
  render() {
    const { formik, isEditing, deal } = this.props;
    const loanStatusId = _.get(formik.values, "details.loanStatusId");
    const isQuote = loanStatusId !== loanStatuses.CLOSED_LOAN && loanStatusId !== loanStatuses.PAID_OFF;

    return (
      <>
        <VerticalSpacer />
        <SectionTitle id="covenants_section">Covenants</SectionTitle>
        <FinancialReportingChildSection formik={formik} isEditing={isEditing} frequencies={_.get(formik.values, "ancillary.frequencies", [])} />
        <VerticalSpacer />
        <FinancialCovenantsChildSection isEditing={isEditing} dscrTypes={_.get(formik.values, "ancillary.dscrTypes", [])} />
        {!isQuote &&
          <>
            <VerticalSpacer />
            <DefinitionsChildSection isEditing={isEditing} />
          </>}
        <VerticalSpacer />
        <CashManagementChildSection isEditing={isEditing} />
        <VerticalSpacer />
        <EscrowAccountsChildSection isQuote={isQuote} isEditing={isEditing} propertySizes={_.get(formik.values, "ancillary.propertySizes", [])} />
        <VerticalSpacer />
        <PartialReleaseChildSection isEditing={isEditing} />
        <VerticalSpacer />
        <LoanPropertyLinkChildSection dealProperties={deal ? deal.properties : []} isEditing={isEditing} />
        <VerticalSpacer />
        <LeasingChildSection isEditing={isEditing} />
      </>
    );
  }
}

const mapStateToProps = ({ }) => ({
});

export default compose(
  connect,
  reduxConnect(
    mapStateToProps,
    {
    }
  )
)(CovenantsSection);
